import React, { useState, useEffect } from 'react';

const NotificationToast = ({ notifications, onRemove }) => {
  const getNotificationIcon = (notification) => {
    if (notification.type === 'followup') return '📅';
    if (notification.type === 'success') return '✅';
    if (notification.type === 'error') return '❌';
    return '🎯';
  };

  const getNotificationColor = (notification) => {
    if (notification.type === 'followup') return 'purple';
    if (notification.type === 'success') return 'green';
    if (notification.type === 'error') return 'red';
    return 'blue';
  };

  const getNotificationTitle = (notification) => {
    if (notification.type === 'followup') return 'Follow-Up Scheduled!';
    if (notification.type === 'success') return 'Success!';
    if (notification.type === 'error') return 'Error!';
    return 'New Lead Captured!';
  };

  return (
    <div className="fixed top-20 right-4 z-50 space-y-3">
      {notifications.map((notification) => {
        const color = getNotificationColor(notification);
        const icon = getNotificationIcon(notification);
        const title = getNotificationTitle(notification);
        
        return (
          <div
            key={notification.id}
            className={`bg-white border-l-4 rounded-lg shadow-2xl p-4 max-w-sm transform transition-all duration-500 ease-in-out animate-slide-in ${
              color === 'purple' ? 'border-purple-500' :
              color === 'green' ? 'border-green-500' :
              color === 'red' ? 'border-red-500' : 'border-blue-500'
            }`}
          >
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
                  color === 'purple' ? 'bg-purple-100' :
                  color === 'green' ? 'bg-green-100' :
                  color === 'red' ? 'bg-red-100' : 'bg-blue-100'
                }`}>
                  <span className={`font-bold ${
                    color === 'purple' ? 'text-purple-600' :
                    color === 'green' ? 'text-green-600' :
                    color === 'red' ? 'text-red-600' : 'text-blue-600'
                  }`}>
                    {icon}
                  </span>
                </div>
              </div>
              <div className="ml-3 flex-1">
                <div className="flex items-center justify-between">
                  <p className="text-sm font-semibold text-gray-900">
                    {title}
                  </p>
                  <button
                    onClick={() => onRemove(notification.id)}
                    className="text-gray-400 hover:text-gray-600 transition-colors"
                  >
                    ✕
                  </button>
                </div>
                
                {/* Handle both old format (with lead object) and new format (with message) */}
                {notification.message ? (
                  <p className="text-sm text-gray-600 mt-1">
                    {notification.message}
                  </p>
                ) : notification.lead ? (
                  <>
                    <p className="text-sm text-gray-600 mt-1">
                      <strong>{notification.lead.name}</strong>
                    </p>
                    <p className="text-xs text-gray-500">
                      {notification.lead.company} • {notification.lead.source}
                    </p>
                    <p className="text-xs text-green-600 font-medium mt-1">
                      Value: ₹{notification.lead.value?.toLocaleString('en-IN')}
                    </p>
                  </>
                ) : null}
              </div>
            </div>
          
          {/* Progress bar for auto-dismiss */}
          <div className="mt-3 bg-gray-200 rounded-full h-1">
            <div 
              className={`h-1 rounded-full transition-all duration-5000 ease-linear ${
                notification.type === 'followup' ? 'bg-purple-500' : 'bg-green-500'
              }`}
              style={{
                animation: notification.type === 'followup' ? 'shrink 3s linear forwards' : 'shrink 5s linear forwards'
              }}
            ></div>
          </div>
        </div>
        );
      })}
      

    </div>
  );
};

export default NotificationToast;
